import AttributeChart from './AttributeChart'

export { compoundKeyFor } from './AttributeChart'
export default AttributeChart
